import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function officeInsight() {
    const els = document.getElementsByClassName('office-insight');

    Array.from(els).forEach(el => {
        const vid = getFirstChild(el.getElementsByTagName('video') , null);

        let tl = gsap.timeline({
            scrollTrigger : {
                trigger : el,
                start : "10% bottom",
                scrub : false,
            }
        });
        tl.add(() => {
            vid.play();
        })
            .from(el.getElementsByTagName('h2'), {xPercent : 100, opacity: 0, duration : 1, rotateY : 90}, 1.8)
            .from(el.getElementsByTagName('p'), {xPercent : 100, opacity: 0, duration: 1, rotateY: 90}, 2.3)
            .from(el.getElementsByClassName('nav-item'), {yPercent : 300, opacity: 0, duration: 0.5});


    });

}

function getFirstChild(collection, d = []) {
    const  a = Array.from(collection);
    return a.length >= 1 ?  a[0] : d;
}

export function animations() {

    const home = document.getElementById('home');

    if(home) {
        homeAnimation(home);
    }

    officeInsight();

}

function homeAnimation(el) {
    gsap.to(el.getElementsByClassName('header-top__star'), { rotate : 360, repeat : -1, ease : 'none', duration:  5});

    gsap.set('.header-bottom__spacer-image', {width :0});

    const tl = gsap.timeline();
    tl.from('.header-top__title-image h1', {yPercent: 20, opacity : 0, duration : 0.5})
        .from('.header-top__description-links p', {yPercent: 20, opacity: 0, duration :0.5})
        .from('.header-top__links .nav-item', { xPercent: 100, opacity : 0, stagger: 0.2}, 0.2)
        .to('.header-bottom__spacer-image', { width: '10.1756955%', duration: 0.5})
        .from('.video-full-width', { yPercent: -100, duration: 0.5, opacity : 0}, 1)
        .from('.header-bottom__square', { yPercent: -300, rotate: 360, opacity : 0, duration : 2}, 0.2)

}


animations();
